import { serialize } from '@/@core/libs/serialize/util'
import Http from './http'

// LIST ALL INSTITUTIONS
export const institutionList = (params = '') => Http.get(`/institutions${serialize(params)}`)
export const institutionCreate = (params = '') => Http.post('/institutions', params)
export const institutionByID = (params = '') => Http.get(`/institutions/${params}`)
export const institutionUpdate = (params = '') => Http.put(`/institutions/${params.id}`, params)
export const institutionDestroy = (params = '') => Http.delete(`/institutions/${params.id}`)
